import React, { useEffect, useState } from 'react';

const withTwoPassRendering = (WrappedComponent: React.ComponentType<any>) =>
  function TwoPass({ children, ...rest }: React.PropsWithChildren<any>) {
    const [isClient, setIsClient] = useState(false);

    useEffect(() => {
      setIsClient(true);
    }, []);

    return (
      <WrappedComponent {...rest} key={String(isClient)}>
        {children}
      </WrappedComponent>
    );
  };

export default withTwoPassRendering;
